<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'bim.cardTitle' | t }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'selectExportTypeBelow' | t }}</h6>
        <hr />
        <button class="btn btn-default me-2 mb-2" (click)="moiExport()">{{ 'bim.moisButton' | t }}</button>
        <button class="btn btn-default me-2 mb-2" (click)="moiSummaryExport()">{{ 'bim.moiSummaryButton' | t }}</button>
        @if (isBimAdmin) {
            <button class="btn btn-default me-2 mb-2" (click)="moiCommentsExport()">
                {{ 'bim.moisAndCommentsButton' | t }}
            </button>
        }
        <button class="btn btn-default me-2 mb-2" (click)="findingReportAssessmentExport()">
            {{ 'bim.findingReportsAssessmentsButton' | t }}
        </button>
        <button class="btn btn-default me-2 mb-2" (click)="findingReportInformationExport()">
            {{ 'bim.findingReportInformationButton' | t }}
        </button>
    </div>
</div>
